var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Table } from "react-bootstrap";
import CustomPagination from "../../../../shared-library/components/CustomPagination";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import { LogoLoader, } from "@frameworks/shared-library/components/Loader";
import Arrows from "@frameworks/web/components/generic/TableHeaderArrows";
import { getSortedData } from "@domains/utils/sort";
var columnList = [
    {
        title: "Lead ID",
        key: "leadId",
        type: "string",
        applySorting: false,
    },
    {
        title: "Name",
        key: "fullName",
        type: "string",
        applySorting: false,
    },
    {
        title: "Assigned to",
        key: "dealerEmpName",
        type: "string",
        applySorting: false,
    },
    {
        title: "Source",
        key: "sourceName",
        type: "string",
        applySorting: false,
    },
    {
        title: "Sub Source",
        key: "subSourceName",
        type: "string",
        applySorting: false,
    },
    {
        title: "Created Date",
        key: "createdDate",
        type: "string",
        applySorting: false,
    },
    {
        title: "Last Updated Date",
        key: "taskProcessDate",
        type: "string",
        applySorting: false,
    },
    {
        title: "Application ID",
        key: "applicationId",
        type: "string",
        applySorting: false,
    },
    {
        title: "Application Status",
        key: "statusName",
        type: "string",
        applySorting: false,
    },
    {
        title: "Lead Status",
        key: "leadStatus",
        type: "string",
        applySorting: true,
    },
];
var AOPLeadTable = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = __read(useState(null), 2), sortingType = _h[0], setSortingType = _h[1];
    var _j = __read(useState(null), 2), clickedIndex = _j[0], setClickedIndex = _j[1];
    var handleArrowClick = function (index) {
        setClickedIndex(index);
    };
    var applySortingAccordingKey = function (key, dataType, sortType, data) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setSortingType(sortType);
                    return [4 /*yield*/, getSortedData(data ? data : (_a = props === null || props === void 0 ? void 0 : props.AOPLeadData) === null || _a === void 0 ? void 0 : _a.data, sortType, key, dataType)];
                case 1:
                    result = _b.sent();
                    props === null || props === void 0 ? void 0 : props.setAOPLeadData(function (prevData) { return (__assign(__assign({}, props === null || props === void 0 ? void 0 : props.AOPLeadData), { data: result })); });
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "aop-leads-table" },
        React.createElement(Table, { responsive: true },
            React.createElement("thead", null,
                React.createElement("tr", null, columnList.map(function (column, idx) {
                    return (React.createElement("th", { key: idx, className: "txt_black-seven DMSansMedium_12_500", onClick: function () {
                            var _a, _b;
                            if (((_b = (_a = props === null || props === void 0 ? void 0 : props.AOPLeadData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                                handleArrowClick(idx);
                                (column === null || column === void 0 ? void 0 : column.applySorting)
                                    ? applySortingAccordingKey(column.key, column.type, !sortingType)
                                    : null;
                            }
                        } }, (column === null || column === void 0 ? void 0 : column.applySorting) ? (React.createElement(Arrows, { sortType: sortingType, key: column === null || column === void 0 ? void 0 : column.key, title: column.title, isClicked: idx === clickedIndex })) : (column.title)));
                }))),
            React.createElement("tbody", null, (_b = (_a = props === null || props === void 0 ? void 0 : props.AOPLeadData) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (data, idx) {
                return (React.createElement("tr", { key: idx },
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", null, (data === null || data === void 0 ? void 0 : data.leadId) ? data === null || data === void 0 ? void 0 : data.leadId : "")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", null, (data === null || data === void 0 ? void 0 : data.fullName) ? data === null || data === void 0 ? void 0 : data.fullName : "-")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", null, (data === null || data === void 0 ? void 0 : data.dealerEmpName) ? data === null || data === void 0 ? void 0 : data.dealerEmpName : "-")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", null, (data === null || data === void 0 ? void 0 : data.sourceName) ? data === null || data === void 0 ? void 0 : data.sourceName : "-")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", null, (data === null || data === void 0 ? void 0 : data.subSourceName) ? data === null || data === void 0 ? void 0 : data.subSourceName : "-")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", { className: "DMSanN_14_400" }, (data === null || data === void 0 ? void 0 : data.createdDate) ? data === null || data === void 0 ? void 0 : data.createdDate : "-")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", { className: "DMSanN_14_400" }, (data === null || data === void 0 ? void 0 : data.taskProcessDate) ? data === null || data === void 0 ? void 0 : data.taskProcessDate : "-")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", null, (data === null || data === void 0 ? void 0 : data.applicationId) ? data === null || data === void 0 ? void 0 : data.applicationId : "-")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", null, (data === null || data === void 0 ? void 0 : data.applicationStatus) ? data === null || data === void 0 ? void 0 : data.applicationStatus : "-")),
                    React.createElement("td", { className: "DMSansNormal_12_400 " },
                        React.createElement("span", null, (data === null || data === void 0 ? void 0 : data.leadStatus) ? data === null || data === void 0 ? void 0 : data.leadStatus : "-"))));
            }))),
        (props === null || props === void 0 ? void 0 : props.loader) && (React.createElement("div", { className: "border-0 loader-height-row w-100" },
            React.createElement("div", { className: "position-relative loader-lead border-0" },
                React.createElement(LogoLoader, null)))),
        !(((_d = (_c = props === null || props === void 0 ? void 0 : props.AOPLeadData) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.length) > 0) && (React.createElement("div", { className: "d-flex justify-content-center" }, !(props === null || props === void 0 ? void 0 : props.loader) && (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Matching Result Found", displayType: ErrorDisplayType.INSECTION })))),
        ((_e = props === null || props === void 0 ? void 0 : props.AOPLeadData) === null || _e === void 0 ? void 0 : _e.totalpages) > 0 && (React.createElement("div", { className: "pagination-footer" },
            React.createElement(CustomPagination, { totalPages: (_f = props === null || props === void 0 ? void 0 : props.AOPLeadData) === null || _f === void 0 ? void 0 : _f.totalpages, getData: function (pageNumber) {
                    props === null || props === void 0 ? void 0 : props.setCurrentPage(pageNumber);
                    setClickedIndex(null);
                }, bubbleClassName: null, activePageClassName: null, currentPage: (_g = props === null || props === void 0 ? void 0 : props.AOPLeadData) === null || _g === void 0 ? void 0 : _g.currentpage })))));
};
export default AOPLeadTable;
